import { change, Field, formValueSelector, reduxForm, reset } from 'redux-form';
import {
  deletePayerServiceCode,
  getPayerOrMasterServiceCodes,
  resetServiceCodeDetails,
  SavePayerServiceCodes,
} from '../../actions';
import GlobalVariables, { alertConfirmation, showNormalizedRate, showWarningMessage } from '../../../../actions/utilAction';
import {
  isInteger,
  normalizeDecimal,
  renderAutoCompleteSingleSelect,
  renderCheckBox,
  renderTextField,
} from '../../../../components/reduxFields';
import Alert from 'react-s-alert';
import classNames from 'classnames';
import { connect } from 'react-redux';
import CptCodeModal from './CptCodeModal';
import PaginatorCustom from '../../../../components/paginationCustom';
import RaisedButton from 'material-ui/RaisedButton';
import React from 'react';
import SortingCustom from '../../../../components/SortingCustom';
import SubString from 'add-ellipsis';
import CircularProgress from 'material-ui/CircularProgress';
import Tooltip from '../../../../components/Tooltip';

const stylescss = {
  block: {
    maxWidth: 250,
  },
  checkbox: {
    marginBottom: 16,
  },
};

class PayerCPTCode extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      payerId: props.payerId,
      pageNumber: 1,
      meta_data: null,
      includedData: [],
      serviceCodeData: null,
      searchServiceCode: null,
      payerServiceCodeID: null,
      payerServiceCodeName: null,
      serviceCodeID: null,
      meta_data_masterCpt: null,
      meta_data_payerCpt: null,
      checkedArray: [],
      isEdit: false,
      newCptList: [],
      masterUnitType: props.master_data ? props.master_data.masterUnitType : [],
      masterRoundingRules: props.master_data ? props.master_data.masterRoundingRules : [],
    };

    this.filter = {
      sort_Column: 'id',
      sort_Order: 'desc',
      searchText: '',
    };

    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.setSortColumn = this.setSortColumn.bind(this);
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleResetButton = this.handleResetButton.bind(this);
  }

  loadData(page_number) {

    let searchObj = {
      filters: {
        PayerId: this.state.payerId,
        SearchText: this.filter.searchText ? this.filter.searchText : undefined,
      },
      pageSize: GlobalVariables.PageSize,
      pageNumber: page_number ? page_number : this.state.pageNumber,
      sort_fields: this.filter.sort_Column ? this.filter.sort_Column : 'id',
      sort_order: this.filter.sort_Order ? this.filter.sort_Order : 'desc',
    };
    this.props.getPayerOrMasterServiceCodes(searchObj);
    // this.props.getAllPayerCptCodeByPayerId(this.state.payerId); // For dropdown
  }

  componentWillMount() {
    this.loadData();
  }

  componentWillReceiveProps = (nextProps) => {
    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      let masterData = nextProps.master_data;
      this.setState({
        masterUnitType: masterData.masterUnitType,
        masterRoundingRules: masterData.masterRoundingRules,
      });
    }

    if (nextProps.payerAdded && nextProps.payerAdded.id) {
      // this.loadData();
      this.setState({ isEdit: true });
    }

    if (nextProps.deletedPayerCpt && this.props.deletedPayerCpt !== nextProps.deletedPayerCpt) {
      this.setState({ checkedArray: [] });
      this.loadData(this.state.pageNumber);
    }

    if (nextProps.payerCptAdded && this.props.payerCptAdded !== nextProps.payerCptAdded) {
      this.loadData();
    }
    if (nextProps.saveSingleCPTCode && this.props.saveSingleCPTCode !== nextProps.saveSingleCPTCode) {
      this.loadData();
    }
    if (nextProps.masterserviceCodesData && this.props.masterserviceCodesData !== nextProps.masterserviceCodesData) {
    //   this.setState({
    //     payerCptCodes: nextProps.payerCptCodes.data,
    //     includedData: nextProps.payerCptCodes.included,
    //     meta_data_masterCpt: nextProps.payerCptCodes.meta,
    //   });
      let masterserviceCodesData = nextProps.masterserviceCodesData && nextProps.masterserviceCodesData.data;
      this.compareCheckedServiceCodes(masterserviceCodesData, nextProps.selectorChecked);
    }

    // if (nextProps.payerCptCodesByPayer && this.props.payerCptCodesByPayer !== nextProps.payerCptCodesByPayer) {
    //   this.setState({
    //     payerCptCodesByPayer: nextProps.payerCptCodesByPayer.data,
    //     includedData: nextProps.payerCptCodesByPayer.included,
    //     meta_data_payerCpt: nextProps.payerCptCodesByPayer.meta,
    //   });
    // }
    if (nextProps.selectorChecked && nextProps.selectorChecked !== this.props.selectorChecked) {
      let masterserviceCodesData = nextProps.masterserviceCodesData && nextProps.masterserviceCodesData.data;
      this.compareCheckedServiceCodes(masterserviceCodesData, nextProps.selectorChecked);
    }
  };

  compareCheckedServiceCodes(masterserviceCodesData, selectorChecked) {
    let selectedArray = (selectorChecked || []).filter((obj, id) => {
      if ((masterserviceCodesData || []).find((cptCode) => cptCode.masterServiceCodeId === id)) {
        return obj.checked;
      } else {
        return false;
      }
    });
    if ((masterserviceCodesData || []).length === (selectedArray || []).length) {
      this.props.dispatch(change('PayerCPTCode', 'CheckAll', true));
    } else {
      this.props.dispatch(change('PayerCPTCode', 'CheckAll', false));
    }
  }

  // to open modal window to add and update ctp/service codes
  handleOpen = (e, serviceCodeObj) => {
    Alert.closeAll();
    e.preventDefault();
    this.props.resetServiceCodeDetails();
    if (serviceCodeObj) {
      this.setState({ open: true, payerServiceCodeID: serviceCodeObj.payerServiceCodeId, payerServiceCodeName: serviceCodeObj.serviceCode });
    } else {
      this.setState({ open: true, serviceCodeID: null, payerServiceCodeID: null, payerServiceCodeName: null });
    }
  };
  handleClose = () => {
    this.setState({ open: false });
  };

  handleResetButton() {
    Alert.closeAll();
    this.filter.sort_Column = 'id';
    this.filter.sort_Order = 'desc';
    this.filter.searchText = '';
    // this.props.dispatch(reset('PayerCPTCode'));
    this.props.dispatch(change('PayerCPTCode', 'ServiceCode', null));
    // this.renderPayerCptCodesByPayer();
    this.loadData();
  }

  handleAlertClick = (event, payerServiceCodeId) => {
    this.props.deletePayerServiceCode(payerServiceCodeId);
    Alert.closeAll();
  };

  handleSearchChange(event) {
    if (event.target.value.length === 0) {
      this.filter.searchText = '';
      this.loadData();
    }
    if (event.target.value && event.target.value.length >= 3) {
      this.filter.searchText = event.target.value;
      this.loadData();
    }
  }

  setSortColumn(col_name, col_order) {
    if (col_name) {
      this.filter.sort_Column = col_name;
      this.filter.sort_Order = col_order;
      this.loadData();
    }
  }
  handleAllEditClick = (input, checked) => {
    if (this.props.masterserviceCodesData) {
      (this.props.masterserviceCodesData.data || []).forEach((cptCode, index) => {
        let service_data = checked ? cptCode : {};
        let id = cptCode.masterServiceCodeId;
        if (service_data) {
          this.props.dispatch(change('PayerCPTCode', `check[${id}].checked`, checked));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].ServiceCode`, service_data.serviceCode || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].Description`, service_data.description || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].UnitDuration`, service_data.unitDuration || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].UnitType`, service_data.unitTypeID || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].RatePerUnit`, showNormalizedRate(service_data.ratePerUnit || 0)));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].RuleID`, service_data.ruleID || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].IsBillable`, service_data.isBillable || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].IsRequiredAuthorization`, service_data.isRequiredAuthorization || null));
          this.props.dispatch(change('PayerCPTCode', `Field[${id}].ServiceCodeId`, service_data.masterServiceCodeId || null));
        }
      });
      let checkedArray = [];
      if (checked) {
        checkedArray = (this.props.masterserviceCodesData.data || []).map((obj) => {
          return {
            Id: obj.masterServiceCodeId,
          };
        });
      }
      this.setState({ checkedArray: checkedArray });
    }
  }

  // edit master ctp codes on checkbox click
  handleEditClick = (input, checked, serviceCodeId) => {
    let id = parseInt(serviceCodeId, 10);
    let service_data = this.props.masterServiceCodesList.find((cpt) => cpt.masterServiceCodeId === id);
    if (service_data) {
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].ServiceCode`, service_data.serviceCode));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].Description`, service_data.description));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].UnitDuration`, service_data.unitDuration));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].UnitType`, service_data.unitTypeID));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].RatePerUnit`, showNormalizedRate(service_data.ratePerUnit)));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].RuleID`, service_data.ruleID));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].IsBillable`, service_data.isBillable));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].IsRequiredAuthorization`, service_data.isRequiredAuthorization));
      this.props.dispatch(change('PayerCPTCode', `Field[${id}].ServiceCodeId`, service_data.masterServiceCodeId));
    }
    // @checkedArray only contains checked(true) ids/values
    // @if checkbox checked(true) - then insert id/value to checkedArray
    if (checked) {
      this.setState((prevState, props) => {
        let prevCheckedArray = [];
        prevCheckedArray = prevState.checkedArray;
        prevCheckedArray.push({ 'Id': id });
        return {
          checkedArray: prevCheckedArray,
        };
      });
    }
    // @if checkbox unchecked(false) - then remove id/value to checkedArray
    if (!checked) {
      this.setState((prevState, props) => {
        let prevCheckedArray = [];
        prevCheckedArray = prevState.checkedArray;
        let index = prevCheckedArray.map(function(x) {
          return x.Id;
        }).indexOf(id);
        prevCheckedArray.splice(index, 1);
        return {
          checkedArray: prevCheckedArray,
        };
      });
    }
  };

  handleDeleteCptCode = (e, Obj) => {
    alertConfirmation('Are you sure, you want to delete this service code for this payer?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleAlertClick,
        id: Obj.payerServiceCodeId,
      },
    });
  };

  handleSearchCpt = (event) => {
    // event.preventDefault();
    if (event.ServiceCode && event.ServiceCode.trim()) {
      this.filter.searchText = event.ServiceCode;
      this.loadData();
    }
  };

  // Save service codes(ctp code) for the payer
  onSubmitHandler(formProps) {
    let formData = [];
    //let dataFormat = {};
    this.state.checkedArray.filter((Obj, index) => {
      let data = formProps.Field[Obj.Id];
      formData.push({
        'PayerId': this.state.payerId,
        'Description': data.Description,
        'RatePerUnit': data.RatePerUnit,
        'UnitType': data.UnitType,
        'ServiceCodeId': data.ServiceCodeId,
        'UnitDuration': data.UnitDuration,
        'RuleID': data.RuleID,
        'IsBillable': data.IsBillable ? data.IsBillable : false,
        'isRequiredAuthorization': data.IsRequiredAuthorization ? data.IsRequiredAuthorization : false,
        'IsActive': true,
      });
      return formData;
    });
    if (formData.length) {
      this.props.SavePayerServiceCodes(formData);
      this.setState({ checkedArray: [] });
      this.props.dispatch(reset('PayerCPTCode'));
    } else {
      return showWarningMessage('Please select atleast one service code?');
    }
  }

  renderPayerOrMasterServiceCodes() {
    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.condensed,
      'table-bordered': this.props.bordered,
      'table-hover': true,
      'table-condensed': this.props.condensed,
      'customtable': true,
    });
    if (this.props.isPayerServiceCodeLength) {
      return (
        <div>
          <table className={tableClass}>
            <thead>
              {this.renderPayerServiceCodesHeader()}
            </thead>
            <tbody>
              {this.renderPayerServiceCodesData()}
            </tbody>
          </table>
          <PaginatorCustom data={this.props.payerOrMasterServiceCodesMeta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
        </div>
      );
    }

    if (!this.props.isPayerServiceCodeLength) {
      return (
        <div>
          <table className={tableClass}>
            <thead>
              {this.renderMasterServiceCodesHeader()}
            </thead>
            <tbody>
              {this.renderMasterServiceCodesData()}
            </tbody>
          </table>
          <PaginatorCustom data={this.props.payerOrMasterServiceCodesMeta} handlePageChange={(pageNumber) => this.loadData(pageNumber)} />
        </div>
      );
    }
  }

  renderPayerServiceCodesHeader() {
    return (
      <tr>
        <th width="10%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='cptCode' displayName='Service Code' /></th>
        <th width="20%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='description' displayName='Description' /></th>
        <th width="10%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='unitDuration' displayName='Unit Duration' /></th>
        <th width="10%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='ratePerUnit' displayName='Rate($)' /></th>
        <th width="20%">Rounding Rule</th>
        <th width="10%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='isBillable' displayName='Billable' /></th>
        <th width="10%"><SortingCustom noSort={!this.props.payerServiceCodesList.length} setSortColumn={this.setSortColumn} columnName='isRequiredAuthorization' displayName='Req. Auth.' /></th>
        <th width="10%">Action</th>
      </tr>
    );
  }

  renderMasterServiceCodesHeader() {
    if (this.props.masterServiceCodesList && this.props.masterServiceCodesList.length === 0) {
      return (
        <tr>
          <th width="10%">&nbsp;</th>
          <th width="13%">Service Code</th>
          <th width="25%">Description</th>
          <th width="10%">Unit Duration</th>
          <th width="10%">Unit Type</th>
          <th width="10%">Rounding Rule</th>
          <th width="10%">Rate($)</th>
          <th width="10%">Billable</th>
        </tr>
      );
    } else if (this.props.masterServiceCodesList && this.props.masterServiceCodesList.length > 0) {
      // let checkedServiceCode = (this.props.selectorChecked || []).filter((obj) => obj).length;
      // let isAllChecked = this.props.masterPayerCptCodes.data.length === checkedServiceCode;
      // console.log(isAllChecked)
      return (
        <tr>
          <th width="5%">
            {this.props.isCheckallLoading ?
              <CircularProgress />
              :
              <Field
                name={'CheckAll'}
                label=""
                component={renderCheckBox}
                onChange={this.handleAllEditClick}
                style={stylescss.checkbox}
              />
            }
          </th>
          <th width="12%"><SortingCustom setSortColumn={this.setSortColumn} columnName='cptCode' displayName='Service Code' /></th>
          <th width="20%"><SortingCustom setSortColumn={this.setSortColumn} columnName='description' displayName='Description' /></th>
          <th width="8%"><SortingCustom setSortColumn={this.setSortColumn} columnName='unitDuration' displayName='Duration' /></th>
          <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='unitType' displayName='Unit Type' /></th>
          <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='ratePerUnit' displayName='Rate($)' /></th>
          <th width="15%">Rounding Rule</th>
          <th width="5%"><SortingCustom setSortColumn={this.setSortColumn} columnName='isBillable' displayName='Billable' /></th>
          <th width="10%"><SortingCustom setSortColumn={this.setSortColumn} columnName='isRequiredAuthorization' displayName='Req. Auth.' /></th>
        </tr>
      );
    }
  }

  renderMasterServiceCodesData() { //  Display master list
    if (this.props.masterServiceCodesList && this.props.masterServiceCodesList.length === 0) {
      return (
        <tr>
          <td colSpan="7">
            <div className="familydl text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }
    if (this.props.masterServiceCodesList && this.props.masterServiceCodesList.length > 0) {
      return this.props.masterServiceCodesList.map((Obj, index) => {
        if (this.state.checkedArray && (this.state.checkedArray.length > 0) && this.state.checkedArray.find((cpt) => cpt.Id === Obj.masterServiceCodeId)) {
          return (
            <tr key={`unchecked-${index}`}>
              <td>
                <Field
                  name={`check[${Obj.masterServiceCodeId}].checked`}
                  label=""
                  component={renderCheckBox}
                  onChange={(input, checked) => this.handleEditClick(input, checked, Obj.masterServiceCodeId)}
                  style={stylescss.checkbox}
                />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].ServiceCode`}
                  disabled={true}
                  type="text"
                  component={renderTextField} />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].Description`}
                  type="text"
                  maxLength="450"
                  component={renderTextField} />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].UnitDuration`}
                  type="text"
                  maxLength="3"
                  normalize={isInteger}
                  component={renderTextField} />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].UnitType`}
                  label=""
                  handleNewRequest={(input, selectedRecord) => input.onChange(selectedRecord.value)}
                  options={this.props.masterUnitType}
                  component={renderAutoCompleteSingleSelect}
                />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].RatePerUnit`}
                  type="text"
                  maxLength="8"
                  normalize={normalizeDecimal}
                  component={renderTextField} />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].RuleID`}
                  label=""
                  handleNewRequest={(input, selectedRecord) => input.onChange(selectedRecord.value)}
                  options={this.props.masterRoundingRules}
                  component={renderAutoCompleteSingleSelect}
                />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].IsBillable`}
                  label=""
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                />
              </td>
              <td>
                <Field
                  name={`Field[${Obj.masterServiceCodeId}].IsRequiredAuthorization`}
                  label=""
                  component={renderCheckBox}
                  style={stylescss.checkbox}
                />
              </td>
            </tr>
          );
        } else {
          return (
            <tr key={index}>
              <td>
                <Field
                  name={`check[${Obj.masterServiceCodeId}].checked`}
                  label=""
                  component={renderCheckBox}
                  onChange={(input, checked) => this.handleEditClick(input, checked, Obj.masterServiceCodeId)}
                  style={stylescss.checkbox}
                />
              </td>
              <td>{Obj.serviceCode}</td>
              <td>
                {Obj.description && Obj.description.length > 0 ?
                  <Tooltip Description={Obj.description} />
                  : null}
                {Obj.description != null && Obj.description.length > 20 ? SubString(Obj.description, 20) : Obj.description != null ? Obj.description : 'N/A'}
              </td>
              <td>
                {Obj.unitDuration}
              </td>
              <td>
                {Obj.unitTypeName}
              </td>
              <td>
                {showNormalizedRate(Obj.ratePerUnit)}
              </td>
              <td>
                {Obj.ruleName}
              </td>
              <td className={Obj.isBillable === true ? 'greenfont' : 'redfont'}>{Obj.isBillable === true ? 'Yes' : 'No'}</td>
              <td className={Obj.isRequiredAuthorization === true ? 'greenfont' : 'redfont'}>{Obj.isRequiredAuthorization === true ? 'Yes' : 'No'}</td>
            </tr>
          );
        }
      });
    }
  }

  renderPayerServiceCodesData() {
    if (this.props.payerServiceCodesList && this.props.payerServiceCodesList.length === 0) {
      return (
        <tr>
          <td colSpan="8">
            <div className="familydl text-center no-record">{this.props.loading ? 'Loading please wait...' : 'No record found.'}</div>
          </td>
        </tr>
      );
    }

    if (this.props.payerServiceCodesList && this.props.payerServiceCodesList.length > 0) {
      return this.props.payerServiceCodesList.map((Obj, index) => {
        return (
          <tr key={index}>
            <td>{Obj.serviceCode}</td>
            <td>
              {Obj.description && Obj.description.length > 0 ?
                <Tooltip Description={Obj.description} />
                : null}
              {Obj.description != null && Obj.description.length > 25 ? SubString(Obj.description, 25, Obj.description.length) + '...' : Obj.description != null ? Obj.description : 'N/A'}</td>
            <td>{Obj.unitDuration} {Obj.unitTypeName}</td>
            <td>{showNormalizedRate(Obj.ratePerUnit)}</td>
            <td>{Obj.ruleName}</td>
            <td width="5%" className={Obj.isBillable === true ? 'greenfont' : 'redfont'}>{Obj.isBillable === true ? 'Yes' : 'No'}</td>
            <td width="5%" className={Obj.isRequiredAuthorization === true ? 'greenfont' : 'redfont'}>{Obj.isRequiredAuthorization === true ? 'Yes' : 'No'}</td>
            <td>
              <button onClick={(e) => this.handleOpen(e, Obj)} type="button" title="Edit" className="tbactionbtn bluefont"><i className="fa fa-pencil-square-o" aria-hidden="true"></i></button>
              <button onClick={(e) => this.handleDeleteCptCode(e, Obj)} type="button" title="Delete" className="tbactionbtn redfont"><i className="fa fa-trash-o" aria-hidden="true"></i></button>
            </td>
          </tr>
        );
      });
    }
  }

  renderAddUpdateServiceCodeButton() {
    if (!this.props.isPayerServiceCodeLength) {
      return (<RaisedButton primary={true} type="submit" label="Update Service Codes"></RaisedButton>);
    } else {
      return (<RaisedButton primary={true} onTouchTap={(e) => this.handleOpen(e, null)} label="Add Service Code"></RaisedButton>);
    }
  }

  render() {
    const { handleSubmit } = this.props;
    return (
      <div>
        <form className="readmin-form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-12 custm_checkstyle">
                <span>Please enter your allowed / contracted rates in this area. The rate you bill to the payer will be in the payer activity section.</span>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-5 filter_btns">
              {this.renderAddUpdateServiceCodeButton()}
              {this.state.open ? <CptCodeModal payerId={this.state.payerId} serviceCodeData={this.state.serviceCodeData} payerServiceCodeID={this.state.payerServiceCodeID} payerServiceCodeName={this.state.payerServiceCodeName} serviceCodeID={this.state.serviceCodeID} closeDialog={this.handleClose} /> : null}
            </div>
            <div className="col-sm-7">
              <div className="row end-flex">
                <div className="col-sm-6 mtm-27">
                  {/* <form className="readmin-form custom_form" onSubmit={ handleSubmit(this.handleSearchCpt.bind(this))}>*/}
                  <Field
                    name="ServiceCode"
                    floatingLabelText="Search"
                    maxLength='15'
                    onChange={this.handleSearchChange}
                    component={renderTextField}
                  />
                  {/* </form>*/}
                </div>
                <div className="reset-btn col-sm-3 btn_rt">
                  <RaisedButton className="grey_btn" primary={true} onTouchTap={this.handleResetButton}>Clear Filter</RaisedButton>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="table-responsive mt-20">
                {this.renderPayerOrMasterServiceCodes()}
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
}


PayerCPTCode = reduxForm({
  form: 'PayerCPTCode',
  enableReinitialize: true, // this is needed!!
})(PayerCPTCode);

const selector = formValueSelector('PayerCPTCode'); // <-- same as form name

function mapStateToProps(state) {
  // console.log('state.payer.payerCptCodesByPayer............', state.payer.get_payer_or_master_service_code);

  let isPayerServiceCodeLength = true;

  let payerOrMasterServiceCodesMeta = null,
    masterserviceCodesData = null,
    payerServiceCodesList = [],
    masterServiceCodesList = [];
  if (state.payer.get_payer_or_master_service_code) {
    payerOrMasterServiceCodesMeta = state.payer.get_payer_or_master_service_code.meta || null;
    let isMasterServiceCodes = (state.payer.get_payer_or_master_service_code.data || []).find((obj) => obj.masterServiceCodeId > 0);

    if (isMasterServiceCodes) {
      isPayerServiceCodeLength = false;
      masterServiceCodesList = state.payer.get_payer_or_master_service_code.data || [];
      masterserviceCodesData = state.payer.get_payer_or_master_service_code || null;
    } else {
      isPayerServiceCodeLength = true;
      payerServiceCodesList = state.payer.get_payer_or_master_service_code.data || [];
    }
  }

  return {
    isPayerServiceCodeLength: isPayerServiceCodeLength,
    loading: state.payer.loading,
    master_data: state.payer.master_data,
    masterUnitType: state.payer.master_data.masterUnitType,
    masterRoundingRules: state.payer.master_data.masterRoundingRules,
    // // masterPayerCptCodes: state.payer.masterPayerCptCodes,
    saveSingleCPTCode: state.payer.saveSingleCPTCode,
    masterserviceCodesData: masterserviceCodesData,
    masterServiceCodesList: masterServiceCodesList,
    payerServiceCodesList: payerServiceCodesList,
    payerOrMasterServiceCodesMeta: payerOrMasterServiceCodesMeta,
    payerCptAdded: state.payer.save_payer_service_code_data,
    deletedPayerCpt: state.payer.delete_payer_service_code,
    ServiceCode: selector(state, 'ServiceCode'),
    selectorChecked: selector(state, 'check'),
  };
}

export default connect(mapStateToProps, {
  deletePayerServiceCode,
  getPayerOrMasterServiceCodes,
  SavePayerServiceCodes,
  resetServiceCodeDetails,
})(PayerCPTCode);



// WEBPACK FOOTER //
// ./src/modules/Payers/containers/payerModule/CptCode.js